import {Pipe, PipeTransform} from '@angular/core';
import {LoggedUser} from '../../common/logged-user.service';

@Pipe({
  name: 'organizationsResolver'
})
export class OrganizationsResolverPipe implements PipeTransform {

  constructor(private loggedUser: LoggedUser) {
  }

  transform(value: string): string {
    if (value === undefined) {
      return '';
    }
    const organization: any = this.loggedUser.userOrganizations.find(entry => entry.uuid === value);
    return organization === undefined ? value : organization.name;
  }

}
